import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import PlaceRolesModel from './PlaceRolesModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/core/parkinglocationgroups';

export default new class ParkinglocationPlacesModel {

  constructor() { }

  async getAll() {
    let filter = {};
    let group = [];
    let groupsResp = await axios.get(BASE, {
      params: {
        access_token: UserModel.getAccessToken(),
        filter: filter
      }
    });
    for (let group of groupsResp.data) {
      group.parkingLocationsIds = [];
      for (let groupParkingLocation of group.parkingLocations) {
        group.parkingLocationsIds.push(groupParkingLocation.plID);
      }
    }
    return groupsResp.data;
  }

  async create(data) {
    let groupResp = await axios.post(BASE,
      Object.assign({}, data, { occ: 0, lastStateChange: moment.utc().format() }), {
      params: {
        access_token: UserModel.getAccessToken()
      }
    });
    return groupResp;
  }

  async remove(id) {
    let groupResp = await axios.delete(BASE + '/' + id, {
      params: {
        access_token: UserModel.getAccessToken()
      }
    });
    return groupResp.data;
  }

  async update(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    let groupResp = await axios.patch(BASE + '/' + id, data, {
      params: {
        access_token: UserModel.getAccessToken()
      }
    });
    return groupResp.data;
  }

}


// WEBPACK FOOTER //
// ./src/components/ParkinglocationGroupsModel.js